import { Injectable } from '@angular/core';
import {HttpAuthService} from '@shared/service/http-auth.service';
import {Observable, zip} from 'rxjs';
import {Headers, RequestMethod, RequestOptions, Response} from '@angular/http';
import {CalendarModel} from '../models/calendar.model';
import {CalendarFilterModel} from '../models/calendar-filter.model';
import {AppConfigEnvironment} from '@shared/models/appconfig-environment.model';
import {AppConfigEnvironmentService} from '@shared/service/appconfig-environment.service';
import {Appointments2Service} from '../../appointments/services/appointments2.service';
import {AppointmentPlannedModel} from '@cc-commons/models/appointment-planned.model';
import {Appointments2} from '../../appointments/models/appointments.model';
import {Utilities} from '@shared/utilities/utilities.model';
import {DateUtilities} from '@shared/utilities/date-utilities.model';
import {Appointments2FilterModel} from '../../appointments/models/appointments2-filter.model';

@Injectable()
export class CalendarService {
    environment: AppConfigEnvironment;

    constructor(private httpAuthService: HttpAuthService,
                private appointmentService: Appointments2Service,
                private appConfig: AppConfigEnvironmentService) {
        this.environment = appConfig.Environment;
    }

    getList(filter?: CalendarFilterModel): Observable<CalendarModel[]>  {
      let url: string = this.environment.CALENDAR + '/events';

        if (filter) {
            url += filter.getFilterUrl().replace(/\+/g, '%2B');
        }
        const options = new RequestOptions();
        return new Observable<CalendarModel[]>(
            observer => {
                this.httpAuthService.get(url, this.environment.ROOT_REDIRECT, options).subscribe(
                    response => {
                        if (response.status === 200) {
                            try {
                                const calendars: CalendarModel[] = [];
                                const json = response.json().items;
                                if (json.length > 0) {
                                    json.forEach(e => calendars.push(e));
                                }
                                observer.next(calendars);
                            } catch (error) {
                                observer.error(error);
                            }
                        } else {
                            observer.next(null);
                        }
                    },
                    error => {
                        observer.error(error);
                    });
            });
    }

    getListForTable(calendarFilterModel: CalendarFilterModel, filterAppointments: Appointments2FilterModel): Observable<any> {
        const options = new RequestOptions();
        let url: string = this.environment.CALENDAR + '/events';
        let url2: string = this.environment.APPOINTMENTS2 + '/appointments';
        url += calendarFilterModel.getFilterUrl().replace(/\+/g, '%2B');
        url2 += filterAppointments.getFilterUrl().replace(/\+/g, '%2B');
        const calendarEvents = this.httpAuthService.get(url, this.environment.ROOT_REDIRECT, options);
        const appointments = this.httpAuthService.get(url2, this.environment.ROOT_REDIRECT, options);
        return  zip(calendarEvents, appointments);
    }


    deleteEvent(eventID: string): Observable<Response> {
        const url: string = this.environment.CALENDAR + '/events/' + eventID;
        const options = new RequestOptions();
        options.headers = new Headers();
        options.headers.set('Content-Type', 'application/json');

        return this.httpAuthService.delete(url, this.environment.ROOT_REDIRECT, options);
    }

    updateEvent(eventID: string, body: any): Observable<Response> {
        const url: string = this.environment.CALENDAR + '/events/' + eventID;
        const options = new RequestOptions();
        options.headers = new Headers();
        options.headers.set('Content-Type', 'application/json');

        return this.httpAuthService.put(url, body, this.environment.ROOT_REDIRECT, options);
    }

    newEvent(body: any): Observable<Response> {
        const url: string = this.environment.CALENDAR + '/events';
        return this.httpAuthService.post(url, body, this.environment.ROOT_REDIRECT, null);
    }

    uploadFile(body: any):  Observable<Response> {
        const url: string = this.environment.CALENDAR + '/events/dedicated_experts/file';
        const options = new RequestOptions();
        options.headers = new Headers();
        options.headers.set('Content-Type', 'application/form-data');

        return this.httpAuthService.post(url, body, this.environment.ROOT_REDIRECT, null);
    }
}
